export const FcfGraphMock = {
  title: 'FCF',
  type: 'FCF',
  navigation: {
    type: 'GraphNavigation',
    nav: {
      qtd: [
        {
          title: 'C',
          graph: {
            data: {
              graph: {
                columnType: 'M',
                data: [
                  {
                    colName: 'Jan',
                    colGroupName: 2023,
                    partial: null,
                    current: {
                      value: 130.0,
                      percent: -24.0,
                    },
                    compare: {
                      value: 172.0,
                      percent: null,
                    },
                    isPreliminary: false,
                    isDefault: false,
                    isFuture: false,
                    cif: null,
                    kmt: null,
                  },
                  {
                    colName: 'Feb',
                    colGroupName: 2023,
                    partial: null,
                    current: {
                      value: 124.0,
                      percent: -24.0,
                    },
                    compare: {
                      value: 163.0,
                      percent: null,
                    },
                    isPreliminary: false,
                    isDefault: true,
                    isFuture: false,
                    cif: null,
                    kmt: null,
                  },
                  {
                    colName: 'Mar',
                    colGroupName: 2023,
                    partial: null,
                    current: {
                      value: 0.0,
                      percent: 0,
                    },
                    compare: {
                      value: 159.0,
                      percent: null,
                    },
                    isPreliminary: false,
                    isDefault: false,
                    isFuture: true,
                    cif: null,
                    kmt: null,
                  },
                  {
                    colName: 'Apr',
                    colGroupName: 2023,
                    partial: null,
                    current: {
                      value: 0.0,
                      percent: 0,
                    },
                    compare: {
                      value: 162.0,
                      percent: null,
                    },
                    isPreliminary: false,
                    isDefault: false,
                    isFuture: true,
                    cif: null,
                    kmt: null,
                  },
                ],
              },
              blocks: [//FCFDataTable[]
                {
                    blocks: [//BlockData[]
                        {//BlockData
                            title: 'O.I' ,
                            values: [0, 112],
                        },
                        {//BlockData
                            title: 'DEP' ,
                            values: [112, 0],
                        },
                        {//BlockData
                            title: 'WC' ,
                            values: [112, 0],
                        },
                        {//BlockData
                            title: 'CAPEX' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'OTHER' ,
                            values: [112, 112],
                        },
                    ]
                },
                {
                    blocks: [
                        {//BlockData
                            title: 'O.I' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'DEP' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'WC' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'CAPEX' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'OTHER' ,
                            values: [112, 112],
                        },
                    ]
                },
                {
                    blocks: [
                        {//BlockData
                            title: 'O.I' ,
                            values: [111, 111],
                        },
                        {//BlockData
                            title: 'DEP' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'WC' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'CAPEX' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'OTHER' ,
                            values: [112, 112],
                        },
                    ]
                },
                {
                    blocks: [
                        {//BlockData
                            title: 'O.I' ,
                            values: [222, 333],
                        },
                        {//BlockData
                            title: 'DEP' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'WC' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'CAPEX' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'OTHER' ,
                            values: [112, 112],
                        },
                    ]
                }
              ],
            },
          },
        },
        {
          title: 'C',
          graph: {
            data: {
              graph: {
                columnType: 'M',
                data: [
                  {
                    colName: 'Jan',
                    colGroupName: 2023,
                    partial: null,
                    current: {
                      value: 130.0,
                      percent: -24.0,
                    },
                    compare: {
                      value: 172.0,
                      percent: null,
                    },
                    isPreliminary: false,
                    isDefault: false,
                    isFuture: false,
                    cif: null,
                    kmt: null,
                  },
                  {
                    colName: 'Feb',
                    colGroupName: 2023,
                    partial: null,
                    current: {
                      value: 124.0,
                      percent: -24.0,
                    },
                    compare: {
                      value: 163.0,
                      percent: null,
                    },
                    isPreliminary: false,
                    isDefault: true,
                    isFuture: false,
                    cif: null,
                    kmt: null,
                  },
                  {
                    colName: 'Mar',
                    colGroupName: 2023,
                    partial: null,
                    current: {
                      value: 0.0,
                      percent: 0,
                    },
                    compare: {
                      value: 159.0,
                      percent: null,
                    },
                    isPreliminary: false,
                    isDefault: false,
                    isFuture: true,
                    cif: null,
                    kmt: null,
                  },
                  {
                    colName: 'Apr',
                    colGroupName: 2023,
                    partial: null,
                    current: {
                      value: 0.0,
                      percent: 0,
                    },
                    compare: {
                      value: 162.0,
                      percent: null,
                    },
                    isPreliminary: false,
                    isDefault: false,
                    isFuture: true,
                    cif: null,
                    kmt: null,
                  },
                ],
              },
              blocks: [//FCFDataTable[]
                {
                    blocks: [//BlockData[]
                        {//BlockData
                            title: 'O.I' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'DEP' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'WC' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'CAPEX' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'OTHER' ,
                            values: [112, 112],
                        },
                    ]
                },
                {
                    blocks: [
                        {//BlockData
                            title: 'O.I' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'DEP' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'WC' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'CAPEX' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'OTHER' ,
                            values: [112, 112],
                        },
                    ]
                },
                {
                    blocks: [
                        {//BlockData
                            title: 'O.I' ,
                            values: [111, 111],
                        },
                        {//BlockData
                            title: 'DEP' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'WC' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'CAPEX' ,
                            values: [112, 112],
                        },
                        {//BlockData
                            title: 'OTHER' ,
                            values: [112, 112],
                        },
                    ]
                },
                {
                    blocks: [
                        {//BlockData
                            title: 'O.I' ,
                            values: [222],
                        },
                        {//BlockData
                            title: 'DEP' ,
                            values: [112],
                        },
                        {//BlockData
                            title: 'WC' ,
                            values: [112],
                        },
                        {//BlockData
                            title: 'CAPEX' ,
                            values: [112],
                        },
                        {//BlockData
                            title: 'OTHER' ,
                            values: [112],
                        },
                    ]
                }
              ],
            },
          },
        },
      ],
    },
  },
};
